// TODO - Add a Progress Bar. Formula of the bar percentage: step*4/100 .
// TODO - Add a Yes or Not question before ask for the URL / Question 8.
// TODO - Add query string to set default values from existing clients.
// TODO - Move the Next Button like the Resume Button. (Remove duplication)
// TODO - Check Git history for changes on the page border color.
<template>
  <div id="app">
    <template v-if="config.intro">
      <div class="uk-section uk-section-small" uk-height-viewport="expand: true">
        <div class="uk-container uk-container-small uk-container-center">
          <img src="https://seisigma.co/images/logos/ss-logo.svg" class="uk-width-1-3 uk-align-center uk-margin-large-top" alt="">
          <div class="uk-text-center uk-position-center">
            <h2>Cuestionario de Visión de su Marca</h2>
            <h3>Permítanos capturar su visión y sus valores para que podamos ayudarlo a construir una identidad de marca
              vibrante.</h3>
            <div>
              <button class="uk-button uk-button-primary" @click="start" @keypress.enter="start"
                uk-tooltip="title: presione ENTER; pos: right">Iniciar</button>
              <!-- <small class="uk-margin-left">Presione <strong>ENTER</strong></small> -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <form @submit.prevent>
        <div class="uk-section uk-section-medium uk-height-1-1" uk-height-viewport="expand: true">
          <div :class="{'uk-container-large': step==27}" class="uk-container uk-container-small uk-flex uk-flex-center uk-flex-middle uk-container-center uk-heigth-1-1">
            <div class="uk-width-2-3">
              <!-- Question 1 - Text - answers.contact.name -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 1">
                  <h3><small class="uk-text-muted">1. </small>¿Cuál es su primer nombre?</h3>
                  <input :class="{'uk-form-danger': $v.answers.contact.name.$error}" class="uk-input" @keydown.space.prevent v-model="answers.contact.name">
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.contact.name.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.contact.name.required" @click="next">Ok</button>
                  </transition>
                </div>
              </transition>
              <!-- Intro - H4 -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 2">
                  <h4 class="uk-text-lead">¡Hola <span v-text="this.answers.contact.name"></span>!<br>
                    Gracias por tomarte el tiempo de completar este cuestionario.<br><br>
                    Sus respuestas nos ayudarán a construir una excelente solución para su negocio. Deseamos contruir una solución fuerte y memorable que perdure en la mente de sus clientes. Por eso debemos definir correctamente quién es usted, que representa y qué los hace diferentes.<br><br>
                  </h4>
                  <transition appear enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" @click="next">¡Continuemos!</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- 2. Acerca de su Negocio -->
              <!-- Question 2 - v-Select - answers.business.industry -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 3">
                  <h2><small class="uk-text-muted">2. </small>Acerca de su Negocio</h2>
                  <h3><small class="uk-text-muted">a. </small>¿En qué industria opera su negocio?</h3>
                  <v-select :class="{'uk-form-danger': $v.answers.business.industry.$error}" @keydown.enter.prevent v-model="answers.business.industry" :options="fields.industries"></v-select>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.business.industry.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.business.industry.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 3 - Textarea - answers.business.history -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 4">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">b. </small>¿Cuáles son los puntos clave en la historia de su negocio?</h3>
                  <h5 class="uk-margin-remove-top">Díganos como inició.</h5>
                  <textarea :class="{'uk-form-danger': $v.answers.business.history.$error}" class="uk-textarea" rows="5" v-model="answers.business.history"></textarea>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.business.history.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.business.history.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 4 - Textarea - answers.business.competitors -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 5">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">c. </small>¿Quíenes son sus principales competidores?</h3>
                  <h5 class="uk-margin-remove-top">Si tienen página web, puede colocarlas aquí. Coloque uno por línea.</h5>
                  <textarea :class="{'uk-form-danger': $v.answers.business.competitors.$error}" class="uk-textarea" rows="5" v-model="answers.business.competitors"></textarea>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.business.competitors.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.business.competitors.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 5 - Textarea - answers.business.advantage -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 6">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">d. </small>¿Qué cosas importantes le caracterizan que destaque su negocio por encima de la competencia?</h3>
                  <h5 class="uk-margin-remove-top">Háblenos de su ventaja competitiva única y los puntos de prueba que dan fe de sus afirmaciones de valor.</h5>
                  <textarea :class="{'uk-form-danger': $v.answers.business.advantage.$error}" class="uk-textarea" rows="5" v-model="answers.business.advantage" placeholder="Nos diferenciamos de nuestros competidores debido a que..."></textarea>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.business.advantage.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.business.advantage.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- 3. Acerca de su Marca -->
              <!-- Question 6 - Title + Radio - answers.brand.typeofproduct -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 7">
                  <h2><small class="uk-text-muted">3. </small>Acerca de su Marca</h2>
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">a. </small>¿Qué representas como marca?</h3>
                  <h5 class="uk-margin-remove-top">Si entiende que aplica más de una opción, seleccione la de mayor relevancia.</h5>
                  <div class="uk-child-width-1-3 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.typeofproduct.$error}" class="uk-radio" v-model="answers.brand.typeofproduct" type="radio" value="Compañía" /> Compañía</label>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.typeofproduct.$error}" class="uk-radio" v-model="answers.brand.typeofproduct" type="radio" value="Productos" /> Producto</label>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.typeofproduct.$error}" class="uk-radio" v-model="answers.brand.typeofproduct" type="radio" value="Servicios" /> Servicio</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.brand.typeofproduct.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.brand.typeofproduct.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 7 - Text - answers.brand.name -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 8">
                  <h3><small class="uk-text-muted">b. </small>¿Cuál es nombre de su marca?</h3>
                  <input :class="{'uk-form-danger': $v.answers.brand.name.$error}" class="uk-input" v-model="answers.brand.name">
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.brand.name.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.brand.name.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 8 - Text (URL Validation) - answers.brand.website -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 9">
                  <h3><small class="uk-text-muted">c. </small>¿Dónde podemos encontrar su página web?</h3>
                  <input :class="{'uk-form-danger': $v.answers.brand.website.$error}" class="uk-input" @keydown.space.prevent v-model="answers.brand.website" placeholder="https://">
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.brand.website.url" class="uk-text-small uk-text-danger">Favor de colocar un URL válido.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.brand.website.url" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 9 - Textarea - answers.brand.values -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 10">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">d. </small>¿Cuál es la misión de su marca?</h3>
                  <h5 class="uk-margin-remove-top">Comparta con nosotros los valores de su marca y explique lo que desea proyectar a través de ella.</h5>
                  <textarea :class="{'uk-form-danger': $v.answers.brand.values.$error}" class="uk-textarea" rows="5" v-model="answers.brand.values"></textarea>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.brand.values.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.brand.values.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 10 - Radio - No Title - answers.brand.description -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 11">
                  <h3><small class="uk-text-muted">e. </small>Si su marca fuera una persona, ¿Cuál de las siguientes ideas le hace sentir que la describe mejor?</h3>
                  <div class="uk-child-width-1-1 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.description.$error}" class="uk-radio" v-model="answers.brand.description" type="radio" id="sincere" value="Sincera" />&nbsp; <strong>Sincera</strong> - Con los Pies sobre la Tierra, Honesta, Saludable, Alegre</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.description.$error}" class="uk-radio" v-model="answers.brand.description" type="radio" id="exciting" value="Excitante" />&nbsp; <strong>Excitante</strong> - Atrevida, Enérgica, Contemporánea, Creatíva</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.description.$error}" class="uk-radio" v-model="answers.brand.description" type="radio" id="competent" value="Competente" />&nbsp; <strong>Competente</strong> - Confiable, Inteligente, Exitosa</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.description.$error}" class="uk-radio" v-model="answers.brand.description" type="radio" id="sophisticated" value="Sofisticada" />&nbsp; <strong>Sofisticada</strong> - Clásica, Glamurosa, Encantadora, Ténue</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.brand.description.$error}" class="uk-radio" v-model="answers.brand.description" type="radio" id="rugged" value="Ruda" />&nbsp; <strong>Ruda</strong> - Masculina, Difícil, Fuerte</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.brand.description.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.brand.description.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- 4. Acerca de su Mercado Objetivo -->
              <!-- Question 11 - Title + Radio - answers.target.target -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 12">
                  <h2><small class="uk-text-muted">4. </small>Acerca de su Mercado Objetivo</h2>
                  <h3><small class="uk-text-muted">a. </small>¿Su cliente meta es?</h3>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.target.target.$error}" class="uk-radio" v-model="answers.target.target" type="radio" id="male" value="Hombre" /> Hombre</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.target.$error}" class="uk-radio" v-model="answers.target.target" type="radio" id="female" value="Mujer" /> Mujer</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.target.$error}" class="uk-radio" v-model="answers.target.target" type="radio" id="female" value="Empresa" /> Empresa</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.target.$error}" class="uk-radio" v-model="answers.target.target" type="radio" id="non" value="Todo" /> Todos los Anteriores</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.target.$error}" class="uk-radio" v-model="answers.target.target" type="radio" id="non" value="N/A" /> No lo sé o No Aplica</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.target.target.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.target.target.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 12 - Radio - No Title - answers.target.age -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 13">
                  <h3><small class="uk-text-muted">b. </small>¿Qué edad tiene su cliente meta?</h3>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="cualquier edad" /> Cualquier Edad</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="17 años o menor" /> 17 años o menor</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="18 a 24" /> Entre 18 a 24</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="25 a 34" /> Entre 25 a 34</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="35 a 44" /> Entre 35 a 44</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="45 a 54" /> Entre 45 a 54</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="55 a 64" /> Entre 55 a 64</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="65 a 74" /> Entre 65 a 74</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="75 a 84" /> Entre 75 a 84</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="85 o mayor" /> 85 o mayor</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.age.$error}" class="uk-radio" v-model="answers.target.age" type="radio" value="N/A" /> No lo sé o No Aplica</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.target.age.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.target.age.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 13 - Radio - No Title - answers.target.status -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 14">
                  <h3><small class="uk-text-muted">c. </small>¿Cuál es el estatus socio-económico de su público?</h3>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="Clase Alta" /> Clase Alta</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="Clase Media" /> Clase Media</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="Clase Baja" /> Clase Baja</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="Clase Trabajadora Calificada" /> Clase Trabajadora Calificada</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="Clase Trabajadora" /> Clase Trabajadora</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="Asalariado de Bajos Ingresos" /> Asalariado de Bajos Ingresos</label><br>
                    <label><input :class="{'uk-form-danger': $v.answers.target.status.$error}" class="uk-radio" v-model="answers.target.status" type="radio" value="N/A" /> No lo sé o No Aplica</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.target.status.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.target.status.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 14 - Radio - No Title - answers.target.learn -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 15">
                  <h3><small class="uk-text-muted">d. </small>¿Cómo encontrarán y aprenderán acerca de su marca?</h3>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Página Web" /> Página Web</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Redes Sociales" /> Redes Sociales</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Tienda" /> Tienda</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Emails" /> Emails</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Anuncios" /> Anuncios</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Ilustración" /> Ilustración</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.learn.$error}" class="uk-checkbox" v-model="answers.target.learn" type="checkbox" value="Otros" /> Otros</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.target.learn.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.target.learn.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 15 - Radio - No Title - answers.target.input -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 16">
                  <h3><small class="uk-text-muted">e. </small>¿Cuál de los siguientes entradas de marketing puede generar mayor impacto en la decisión de compra de sus clientes?</h3>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input :class="{'uk-form-danger': $v.answers.target.input.$error}" class="uk-radio" v-model="answers.target.input" type="radio" value="productos" /> Producto</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.input.$error}" class="uk-radio" v-model="answers.target.input" type="radio" value="ubicaciones" /> Lugar</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.input.$error}" class="uk-radio" v-model="answers.target.input" type="radio" value="promociones" /> Promoción</label>
                    <label><input :class="{'uk-form-danger': $v.answers.target.input.$error}" class="uk-radio" v-model="answers.target.input" type="radio" value="precios" /> Precio</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.target.input.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.target.input.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 16 - Textarea - answers.target.desc -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 17">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">f. </small>¿Qué más puede compartirnos acerca de sus clientes?</h3>
                  <h5 class="uk-margin-remove-top">Describa brevemente sus valores, el proceso de toma de decisiones y, si ya tiene una marca, cómo la perciben actualmente.</h5>
                  <textarea :class="{'uk-form-danger': $v.answers.target.desc.$error}" class="uk-textarea" rows="5" v-model="answers.target.desc"></textarea>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.target.desc.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.target.desc.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- 5. Acerca del Proyecto -->
              <!-- Question 17 - Title + Radio - answers.project.brandingManual -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 18">
                  <h2><small class="uk-text-muted">5. </small>Acerca del Proyecto</h2>
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">a. </small>¿Posee un manual de marca?</h3>
                  <h5 class="uk-margin-remove-top">Un documento que explique los colores y usos de los elementos que representan la marca de su empresa.</h5>
                  <div class="uk-child-width-1-3 uk-grid-small" uk-grid>
                    <label><input class="uk-radio" v-model="answers.project.brandingManual" type="radio" value="Si" /> Si</label>
                    <label><input class="uk-radio" v-model="answers.project.brandingManual" type="radio" value="No" /> No</label>
                  </div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.project.brandingManual.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.project.brandingManual.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 18 - Radio - No Title - answers.project.budget -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 19">
                  <h3><small class="uk-text-muted">b. </small>¿Cuál es su rango de presupuesto para este proyecto?</h3>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input class="uk-radio" v-model="answers.project.budget" type="radio" value="US$ 1,000 o Menos" /> US$ 1,000 o Menos</label>
                    <label><input class="uk-radio" v-model="answers.project.budget" type="radio" value="US$ 1,000 a US$ 3,000" /> US$ 1,000 a US$ 3,000</label>
                    <label><input class="uk-radio" v-model="answers.project.budget" type="radio" value="US$ 3,000 a US$ 5,000" /> US$ 3,000 a US$ 5,000</label>
                    <label><input class="uk-radio" v-model="answers.project.budget" type="radio" value="US$ 5,000 a US$ 7,500" /> US$ 5,000 a US$ 7,500</label>
                    <label><input class="uk-radio" v-model="answers.project.budget" type="radio" value="US$ 7,500 a US$ 10,000" /> US$ 7,500 a US$ 10,000</label>
                    <label><input class="uk-radio" v-model="answers.project.budget" type="radio" value="Más de US$ 10,000" /> Más de US$ 10,000</label>
                  </div>
                  <div class="uk-alert uk-alert-primary uk-text-small uk-margin-top"><span uk-icon="info"></span> Si ya ha aceptado una propuesta puede obviar esta pregunta.</div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.project.budget.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.project.budget.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 19 - Checkbox - answers.project.services -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 20">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">c. </small>¿En cuáles servicios está interesado?</h3>
                  <h5 class="uk-margin-remove-top">Selecciones todos los servicios que desee contratar.</h5>
                  <div class="uk-child-width-1-2 uk-grid-small" uk-grid>
                    <label><input class="uk-checkbox" v-model="answers.project.services" type="checkbox" value="Diseño Web" /> Página Web</label>
                    <label><input class="uk-checkbox" v-model="answers.project.services" type="checkbox" value="Aplicación Móbil" /> Aplicación Móbil</label>
                    <label><input class="uk-checkbox" v-model="answers.project.services" type="checkbox" value="Diseño de Marca" /> Diseño de Marca</label>
                    <label><input class="uk-checkbox" v-model="answers.project.services" type="checkbox" value="UX/UI" /> UX/UI</label>
                    <label><input class="uk-checkbox" v-model="answers.project.services" type="checkbox" value="Ilustración" /> Ilustración</label>
                  </div>
                  <div class="uk-alert uk-alert-primary uk-text-small uk-margin-top"><span uk-icon="info"></span> Si ya ha aceptado una propuesta puede obviar esta pregunta.</div>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.project.services.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.project.services.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 20 - Textarea - answers.project.expectations -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 21">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">d. </small>¿Cuáles son sus objetivos y expectativas para este proyecto?</h3>
                  <h5 class="uk-margin-remove-top">Asegúrese de especificar sus requisitos y plazos de entrega, así como también cualquier estándar o restricción de diseño en particular que desee que tengamos en cuenta.</h5>
                  <textarea :class="{'uk-form-danger': $v.answers.project.expectations.$error}" class="uk-textarea" rows="5" v-model="answers.project.expectations" placeholder="Manejar... Incluir... Evitar... El proyecto dispone de un plazo de ... días|meses|años. Es importante que no... y evitar..."></textarea>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.project.expectations.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.project.expectations.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- 6. Acerca de Usted -->
              <!-- Question 21 - Text - answers.contact.lname -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 22">
                  <h2><small class="uk-text-muted">6. </small>Acerca de Usted</h2>
                  <h3><small class="uk-text-muted">a. </small>¿Cuál es su apellido?</h3>
                  <input :class="{'uk-form-danger': $v.answers.contact.lname.$error}" class="uk-input" @keydown.space.prevent v-model="answers.contact.lname">
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.contact.lname.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.contact.lname.required" @click="next">Ok</button>
                  </transition>
                </div>
              </transition>
              <!-- Question 22 - v-Select - answers.contact.country -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 23">
                  <h3><small class="uk-text-muted">b. </small>¿Cuál es su país de origen?</h3>
                  <v-select @keyup.enter.prevent="" v-model="answers.contact.country" :options="fields.countries"></v-select>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.contact.country.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.contact.country.required" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 23 - Text (Email Validation) - answers.contact.email -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 24">
                  <h3><small class="uk-text-muted">c. </small>¿Cuál es su correo electrónico?</h3>
                  <input :class="{'uk-form-danger': $v.answers.contact.email.$error}" class="uk-input" @keydown.space.prevent v-model="answers.contact.email">
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div v-if="!$v.answers.contact.email.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                    <div v-if="!$v.answers.contact.email.email" class="uk-text-small uk-text-danger">Favor de colocar un Email válido.</div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.contact.email.required && $v.answers.contact.email.email" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 24 - Text - answers.contact.phone -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 25">
                  <h3 class="uk-margin-remove-bottom"><small class="uk-text-muted">d. </small>¿Cuál es su número telefónico?</h3>
                  <h5 class="uk-margin-remove-top">Solo números sin guiones ni paréntesis.</h5>
                  <input :class="{'uk-form-danger': $v.answers.contact.phone.$error}" class="uk-input" @keydown.space.prevent v-model="answers.contact.phone">
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <div>
                      <div v-if="!$v.answers.contact.phone.required" class="uk-text-small uk-text-danger">Este campo es obligatorio.</div>
                      <div v-if="!$v.answers.contact.phone.numeric" class="uk-text-small uk-text-danger">Favor de colocar un Teléfono válido.</div>
                      <div v-if="!$v.answers.contact.phone.minLength" class="uk-text-small uk-text-danger">El número telefónico debe disponer de por lo menos 7 dígitos.</div>
                    </div>
                  </transition>
                  <transition enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" v-if="$v.answers.contact.phone.required && $v.answers.contact.phone.numeric && $v.answers.contact.phone.minLength" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Question 25 - Textarea - answers.comments -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-large-top" v-if="step == 26">
                  <h3><small class="uk-text-muted">7. </small>¿Desea compartir alguna otra información, comentario o solicitud?</h3>
                  <textarea class="uk-textarea" rows="5" v-model="answers.comments"></textarea>
                  <transition appear enter-active-class="animated bounceIn" leave-active-class="uk-invisible" mode="in-out">
                    <button class="uk-button uk-button-primary uk-width-1-3 uk-margin-top" @click="next">Ok</button>
                  </transition>
                  <go-back @goBack="back"></go-back>
                </div>
              </transition>
              <!-- Thanks and Review - H4 -->
              <transition appear enter-active-class="animated fadeIn" mode="out-in">
                <div class="uk-margin-top" v-if="step == 27">
                  <h4 class="uk-text-lead">¡Listo! Haz respondido todas la preguntas.</h4>
                  <p class="uk-text-lead">Haz completado el cuestionario de Visión de Marca de tu empresa. A continuación te mostramos como hemos organizado tus respuestas:</p>
                  <div class="uk-text-lead ss-letter">
                    <div class="uk-alert uk-alert-primary uk-text-small"><span uk-icon="info"></span> Si desea editar alguna de las informaciones suministradas, solo debe clickear sobre la opción que desee modificar.</div>
                      <div class="body">
                        <p>Hola,<br>
                        Mi nombre es <a @click.prevent="step=1">{{answers.contact.name}}</a>&nbsp;<a @click.prevent="step=22">{{answers.contact.lname}}</a>, represento a <a @click.prevent="step=8">{{answers.brand.name}}</a>. Somos una empresa de <a @click.prevent="step=3">{{answers.business.industry}}</a> establecida en <a @click.prevent="step=23">{{answers.contact.country}}</a>.
                        Buscamos una empresa que nos brinde los siguientes servicios: <span v-if="answers.project.services.length > 1"><span v-for="(service, index) in answers.project.services" :key="index"><a v-if="((answers.project.services.length-1) - index) > 0" @click.prevent="step=20">{{service}}<span v-if="(index+2) != answers.project.services.length">, </span></a><a v-else @click.prevent="step=20"> y {{service}}</a></span></span><span v-else><a @click.prevent="step=20" v-for="service in answers.project.services" :key="service">{{service}}</a></span>.
                        El presupuesto del proyecto debe rondar entre los <a @click.prevent="step=19">{{answers.project.budget}}</a>. Deseamos que nuestro proyecto cumpla con las siguientes expectativas <a @click.prevent="step=21">{{answers.project.expectations}}</a>.</p>
                        <p>Somos una empresa <a @click.prevent="step=11">{{answers.brand.description}}</a>. Deseamos presentar <span v-if="answers.brand.typeofproduct == 'Compañía'">a la </span><span v-else>nuestros </span> <a @click.prevent="step=7">{{answers.brand.typeofproduct}}</a> como nuestra principal marca. Nos diferenciamos de nuestros competidores debido a que <a @click.prevent="step=6">{{answers.business.advantage}}</a>.
                        Estos son algunos competidores que pueden consultar relacionados a nuestro negocio: <a @click.prevent="step=5">{{answers.business.competitors}}</a>.</p>
                        <p>Nuestro público meta es <a @click.prevent="step=12">{{answers.target.target}}</a> entre los <a @click.prevent="step=13">{{answers.target.age}}</a>, de clase <a @click.prevent="step=14">{{answers.target.status}}</a>, descrito como <a @click.prevent="step=17">{{answers.target.desc}}</a>, que nos encontrarán principalemente a través de los siguientes canales:
                        <span v-if="answers.target.learn.length > 1"><span v-for="(channel, index) in answers.target.learn" :key="index"><a v-if="((answers.target.learn.length-1) - index) > 0" @click.prevent="step=20">{{channel}}<span v-if="(index+2) != answers.target.learn.length">, </span></a><a v-else @click.prevent="step=20"> y {{channel}}</a></span></span><span v-else><a @click.prevent="step=20" v-for="channel in answers.target.learn" :key="channel">{{channel}}</a></span>, entendiendo que nuestro
                        mayor impacto es a través de <span v-if="answers.target.input == 'productos' || answers.target.input == 'precios' ">nuestros </span><span v-else>nuestras </span> <a @click.prevent="step=16">{{answers.target.input}}</a>.</p>
                        <p v-if="answers.brand.website">Actualmente poseemos página web, la cual puede ser accedida a través de la URL <a @click.prevent="step=9">{{answers.brand.website}}</a>.</p>
                        <p v-if="answers.project.brandingManual">Puede solicitar nuestro manual corporativo para trabajar nuestro proyecto en base a nuestra marca.</p>
                        <p>Puede contactarnos a través de nuestro correo electrónico <a @click.prevent="step=24">{{answers.contact.email}}</a> o a través de nuestro número telefónico <a @click.prevent="step=25">{{answers.contact.phone}}</a>.</p>
                        <p>Como nuevos clientes, deseamos compartir quíenes somos y un poco de nuestra historia para entiendan cómo deseamos proyectarnos antes nuestros clientes:</p>
                        <div class="uk-alert">
                          <h4 class="uk-margin-remove uk-text-bold">Nuestra Historia</h4>
                          <p class="uk-margin-remove-top"><a @click.prevent="step=4">{{answers.business.history}}</a></p>
                          <h4 class="uk-margin-remove uk-text-bold">Nuestros Valores</h4>
                          <p class="uk-margin-remove-top"><a @click.prevent="step=10">{{answers.brand.values}}</a></p>
                          <h4 class="uk-margin-remove uk-text-bold">Comentarios, Notas & Solicitudes</h4>
                          <p class="uk-margin-remove-top"><a @click.prevent="step=10">{{answers.comments}}</a></p>
                        </div>
                        <p>¡Gracias!</p>
                    </div>
                  </div>
                  <div id="test" class="uk-alert uk-alert-primary">
                    Si estás de acuerdo con la información suministrada puedes presionar el botón de "Enviar". Nuestro analista de proyecto estará revisando sus requerimientos y le estaremos respondiendo a la mayor brevedad posible.
                    <button class="uk-button uk-button-secondary uk-width-1-3 uk-align-center uk-margin-top" @click="sentResults" uk-tooltip="title: Al presionar el botón 'Enviar', usted confirma ser propietario de la información suministrada y acepta el compartir los datos publicados en este formulario con SEISIGMA SRL.; pos: left">Enviar</button>
                  </div>
                </div>
              </transition>
              <a v-if="done && step != 27 && !$v.$invalid" class="uk-button uk-button-secondary uk-margin-top uk-width-1-1 uk-icon-link" @click="step=27"><span uk-icon="icon: chevron-double-right"></span>Volver al Resumen Final</a>
            </div>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
// Global Resources
import 'vue-select/dist/vue-select.css'
import { required, minLength, url, numeric, email } from 'vuelidate/lib/validators'

// Data Resources
import { industries } from './resources/industries.js'
import { countries } from './resources/countries.js'

import UIkit from 'uikit'

// Project Components
import GoBack from './components/goback'

// EmailJS
import emailjs from '@emailjs/browser'

// Component Vue Instance
export default {
  name: 'app',
  data () {
    return {
      step: 0,
      done: false,
      config: {
        intro: true,
        customStyles: {
          clientColor: ''
        }
      },
      fields: {
        industries: industries,
        countries: countries
      },
      answers: {
        contact: {
          name: '',
          lname: '',
          country: '',
          email: '',
          phone: ''
        },
        business: {
          industry: '',
          history: '',
          competitors: '',
          advantage: ''
        },
        brand: {
          typeofproduct: '',
          name: '',
          website: '',
          values: '',
          description: ''
        },
        target: {
          target: '',
          age: '',
          status: '',
          learn: [],
          input: '',
          desc: ''
        },
        project: {
          brandingManual: false,
          budget: '',
          services: [],
          expectations: ''
        },
        comments: ''
      }
    }
  },
  validations: {
    answers: {
      contact: {
        name: { required },
        lname: { required },
        country: { required },
        email: { required, email },
        phone: { required, numeric, minLength: minLength(7) }
      },
      business: {
        industry: { required },
        history: { required },
        competitors: { required },
        advantage: { required }
      },
      brand: {
        typeofproduct: { required },
        name: { required },
        website: { url },
        values: { required },
        description: { required }
      },
      target: {
        target: { required },
        age: { required },
        status: { required },
        learn: { required },
        input: { required },
        desc: { required }
      },
      project: {
        brandingManual: { required },
        budget: { required },
        services: { required },
        expectations: { required }
      }
    }
  },
  methods: {
    start () {
      this.config.intro = false
      this.step++
    },
    next () {
      this.step++
    },
    back () {
      if (this.step > 1) {
        this.step--
      } else {
        return false
      }
    },
    sentResults (e) {
      UIkit.modal.dialog(`<div class="uk-padding-large uk-text-center" uk-alert><span class="uk-text-lead">Estamos enviando su solicitud...</span><div class="spinner"></div></div>`, {
        escClose: false,
        bgClose: false
      })

      let templateParams = this.answers
      emailjs.send('service_c8s4r09', 'seisigma_project_form', templateParams, {
        publicKey: 'YCauS4GyQplYqhrG_'
      }).then(
        (response) => {
          UIkit.modal.dialog(`<div class="uk-alert-success uk-padding-large uk-padding-remove-left uk-padding-remove-right uk-text-center" uk-alert><span class="animated bounceIn delay-1s" uk-icon="icon: check; ratio: 1.4"></span> <span class="uk-text-lead uk-text-success animated rubberBand delay-2s">Su mensaje ha sido enviado exitosamente.</span><br /><a class="uk-button uk-button-default uk-margin-top uk-text-success animated bounceIn delay-3s" href="https://seisigma.co">Ir a SEISIGMA</a></div>`, {
            escClose: false,
            bgClose: false
          })
          console.log('Success...', response)
        },
        (error) => {
          console.log('Failed...', error)
        }
      )

      // emailjs.send('service_c8s4r09', 'seisigma_project_form', templateParams, 'user_mhMSmj7UyVt6AxyHBhzZm').then(function (response) {
      //   console.log('SUCCESS!', response.status, response.text)
      //   UIkit.modal.dialog(`<div class="uk-alert-success uk-padding-large uk-padding-remove-left uk-padding-remove-right uk-text-center" uk-alert><span class="animated bounceIn delay-1s" uk-icon="icon: check; ratio: 1.4"></span> <span class="uk-text-lead uk-text-success animated rubberBand delay-2s">Su mensaje ha sido enviado exitosamente.</span><br /><a class="uk-button uk-button-default uk-margin-top uk-text-success animated bounceIn delay-3s" href="https://seisigma.co">Ir a SEISIGMA</a></div>`, {
      //     escClose: false,
      //     bgClose: false
      //   })
      // }, function (error) {
      //   console.log('FAILED...', error)
      // })
    }
  },
  watch: {
    step () {
      if (this.step === 27) {
        this.done = true
      }
    }
  },
  components: {
    GoBack
  },
  mounted () {
    window.addEventListener('keyup', event => {
      if (event.keyCode === 13 && this.config.intro === true) {
        this.start()
      }
    })
  }
}

</script>

<style>
  .ss-letter{
    margin: 10px 0;
    padding: 75px 100px 50px;
    background: #FFF;
    border: 1px solid #ccc;
  }
  .ss-letter > .body{
    font-family: 'Neuton', serif;
    text-align: justify;
  }

  /* Spinner CSS */
  .spinner {
    width: 40px;
    height: 40px;
    background-color: #3e465b;
    margin: 20px auto 0;
    -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
    animation: sk-rotateplane 1.2s infinite ease-in-out;
  }

  @-webkit-keyframes sk-rotateplane {
    0% { -webkit-transform: perspective(120px) }
    50% { -webkit-transform: perspective(120px) rotateY(180deg) }
    100% { -webkit-transform: perspective(120px) rotateY(180deg)  rotateX(180deg) }
  }

  @keyframes sk-rotateplane {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
    } 50% {
      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
    } 100% {
      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
      -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    }
  }
</style>
